import type { SynonymPrice } from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/LpuPrices/types'
import type { MedflexService } from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/price/_components/PriceSection/types/medflex'

/** Приводит услугу полного прайса к строке `PricesServiceRow`. */
export default function mapMedflexService(service: MedflexService): SynonymPrice {
  return {
    id: service.synonym_id,
    name: service.name,
    duration: service.duration,
    price: service.prices?.full,
    synonym_id: service.synonym_id,
    appointment_on: service.appointment_on,
    has_intervals: service.has_intervals,
    is_available_appointment_direct: service.is_available_appointment_direct,
    allow_treatment_referral: service.allow_treatment_referral,
    requires_primary_consultation: service.requires_primary_consultation,
    has_primary_consultation_doctors: service.has_primary_consultation_doctors,
    doctor_specialities: service.doctor_specialities,
    translations: service.translations,
  }
}
